import { render, staticRenderFns } from "./LanguageModal.vue?vue&type=template&id=a34974e4&scoped=true"
import script from "./LanguageModal.vue?vue&type=script&lang=js"
export * from "./LanguageModal.vue?vue&type=script&lang=js"
import style0 from "./LanguageModal.vue?vue&type=style&index=0&id=a34974e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34974e4",
  null
  
)

export default component.exports